/* src/app/views/admin/user-wallet/user-wallet.component.css */
/*# sourceMappingURL=user-wallet.component.css.map */
